:root {
  --stepIndicatorHeight: 34px;
  --arrowSize: calc(var(--stepIndicatorHeight) / 2);
  --upperArrowSize: calc(var(--arrowSize) - 1px);
}

.navigation {
  display: flex;
  justify-content: flex-end;

  & > * {
    margin-left: 1em;
  }
}

.stepIndicatorContainer {
  border: 1px solid var(--blue);
  display: inline-block;
  margin: 0 0 2em;
}

.stepIndicator {
  height: var(--stepIndicatorHeight);
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  line-height: var(--stepIndicatorHeight);
  padding: 0 3em;
  pointer-events: none;

  &::before {
    content: "";
    position: absolute;
    right: calc(-1 * var(--arrowSize));
    top: 0;
    width: 0;
    height: 0;
    border-top: var(--arrowSize) solid transparent;
    border-bottom: var(--arrowSize) solid transparent;
    border-left: var(--arrowSize) solid var(--blue);
  }

  &:last-child::before {
    display: none;
  }

  &::after {
    content: "";
    position: absolute;
    right: calc(-1 * var(--arrowSize) + 1px);
    top: 1px;
    width: 0;
    height: 0;
    border-top: var(--upperArrowSize) solid transparent;
    border-bottom: var(--upperArrowSize) solid transparent;
    border-left: var(--upperArrowSize) solid var(--white);
    z-index: 1;
  }

  &:last-child::after {
    display: none;
  }
}

.activeStepIndicator {
  color: var(--white);
  background-color: var(--blue);

  &::after {
    display: none;
  }
}

.formItem {
  margin: 2em 0;
}

.inputWithButton {
  display: flex;
  justify-content: flex-end;

  & > input {
    flex: 1;
  }
}

.titleWithButton {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  & span {
    flex: 1;
  }

  & button {
    margin-left: 0.5em;
  }
}

.successMessage {
  font-weight: bold;
}
